import React          from "react"
import {Box}           from "@mui/material"
import BirdsyMiniMark  from "./BirdsyMiniMark"

/*
 * The clickable Birdsy mark in the top-left, shared by the Navbar and study mode (081).
 *
 * It exists so the two cannot drift apart. They previously wrapped BirdsyMiniMark themselves
 * and the wrappers disagreed: BirdsyMiniMark renders a MUI SvgIcon, which is inline-block, so
 * without `lineHeight: 0` it sits on a text baseline and the line box adds descender space
 * below it. That made the Navbar's wrapper taller than study mode's, and centring a taller box
 * in the same band put the mark a few pixels higher — so the logo jumped when navigating
 * between the dashboard and a question.
 *
 * display:flex + lineHeight:0 makes the wrapper hug the artwork exactly, in both places.
 */
const BrandMark = ({width = 60, onClick, sx}) => (
	<Box
		onClick={onClick}
		sx={{
			cursor: 'pointer',
			display: 'flex',
			alignItems: 'center',
			lineHeight: 0,
			pt: '5px',
			...sx,
		}}
	>
		<BirdsyMiniMark width={width}/>
	</Box>
)

export default BrandMark
